import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-circle",
  "use": "icon-close-circle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-close-circle\"><path d=\"M7 0a7 7 0 107 7 7 7 0 00-7-7zm3.208 9.382l-.818.826L7 7.819l-2.389 2.389-.82-.82L6.179 7 3.792 4.611l.82-.82L7 6.177l2.382-2.385.826.818-2.387 2.384 2.387 2.388z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol